module.exports = __webpack_public_path__ + "static/img/img4.9ee18bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4/img4.png
// module id = U1n9
// module chunks = 0